<template>
  <div class="container lnb d_container">
    <div class="contents_wrap no_height">
      <div class="contents list-container">
        <div class="title">{{ this.$route.meta.title }}</div>
        <div class="write_tab mb20">
          <div class="write_tab_content tab_member_detail" @click="$router.push(`/item/utility/${utilKey}`)">
            기본정보
          </div>
          <div class="write_tab_content tab_member_detail active">
            매니저
          </div>
          <div class="write_tab_content tab_member_detail " @click="movePage(`/item/utility/${utilKey}/pubcurrent`)">
            발행현황
          </div>
        </div>
        <utility-pub-list-component :utility-type="'utilityManager'" :utilKey="utilKey"></utility-pub-list-component>
      </div>
    </div>
  </div>
</template>
<script>
import UtilityPubListComponent from "@/components/utility/UtilityPubListComponent.vue";
import EventBus from "@/utils/event-bus";

export default {
  name: "UtilityDetailManager",
  mixins: [],
  components: {UtilityPubListComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      utilKey: Number(this.$route.params.idx),
    }
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    movePage(url) {
        EventBus.$emit('apiLoading', true);
      this.$router.push(url);
    },
  },
  watch: {},
}
</script>

<style scoped>

</style>
